import type { ILanguageResources, ITranslationModule } from '../../../interfaces';
import { interpolate } from '../../../global';

class Id {
  private constructor() {}
  public static readonly prefix = 'UI.scripts.franchisee.view.FranchiseeBrandingView.';

  public static readonly branding = `${Id.prefix}branding`;
  public static readonly provideValidColorLogo = `${Id.prefix}provideValidColorLogo`;
  public static readonly provideValidWhiteLogo = `${Id.prefix}provideValidWhiteLogo`;
  public static readonly brandingSaved = `${Id.prefix}brandingSaved`;
  public static readonly unableToUploadLogo = `${Id.prefix}unableToUploadLogo`;
  public static readonly uploadMsg = `${Id.prefix}uploadMsg`;
  public static readonly colorLogo = `${Id.prefix}colorLogo`;
  public static readonly whiteLogo = `${Id.prefix}whiteLogo`;
  public static readonly specifications = `${Id.prefix}specifications`;
}

export class LangFranchiseeBrandingView {
  private constructor() {}

  public static branding(): string {
    return interpolate(Id.branding);
  }
  public static provideValidColorLogo(): string {
    return interpolate(Id.provideValidColorLogo);
  }
  public static provideValidWhiteLogo(): string {
    return interpolate(Id.provideValidWhiteLogo);
  }
  public static brandingSaved(): string {
    return interpolate(Id.brandingSaved);
  }
  public static unableToUploadLogo(): string {
    return interpolate(Id.unableToUploadLogo);
  }
  public static uploadMsg(): string {
    return interpolate(Id.uploadMsg);
  }
  public static colorLogo(): string {
    return interpolate(Id.colorLogo);
  }
  public static whiteLogo(): string {
    return interpolate(Id.whiteLogo);
  }
  public static specifications(): string {
    return interpolate(Id.specifications);
  }
}

export class FranchiseeBrandingViewModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    register.add(Id.branding, 'Branding', 'Section title for branding');
    register.add(Id.provideValidColorLogo, 'Please provide a valid Color Logo', 'Validation for color logo');
    register.add(Id.provideValidWhiteLogo, 'Please provide a valid White Logo', 'Validation for white logo');
    register.add(Id.brandingSaved, 'Branding saved', 'Toast message for branding saved');
    register.add(Id.unableToUploadLogo, 'Unable to upload Logo', 'Error message for logo upload failure');
    register.add(
      Id.uploadMsg,
      "Please upload your business logo<br>This will be incorporated into documents sent to {{glossary 'client'}} and {{glossary 'supplier'}}, such as {{glossary 'estimate:plural'}}/{{glossary 'invoice:plural'}}/{{glossary 'purchase-order:plural'}}.\n\nChoose a logo to appear at the top of PDFs and reports you print or send.<br>The minimum permitted size is **800(W) x 400(H)** pixels.<br>The ideal size of your logo is **1600(W) x 800(H)** pixels.<br>The image must be **300DPI** in quality and in the **jpg** format on a white background.<br>If the aspect ratio of your logo is different, it will be scaled down in proportion to fit the template constraints.",
      'Markdown message for branding upload instructions'
    );
    register.add(Id.colorLogo, 'Color Logo', 'Label for color logo image picker');
    register.add(Id.whiteLogo, 'White Logo', 'Label for white logo image picker');
    register.add(Id.specifications, 'Specifications', 'Section header for branding specifications');
  }
}
